// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__3FwSQ","logoImg":"Logo_logoImg__qTZA7","logoText":"Logo_logoText__j6i24"};